import { render, staticRenderFns } from "./lottery-goods-info.vue?vue&type=template&id=1c2b5fc6&"
import script from "./lottery-goods-info.vue?vue&type=script&lang=js&"
export * from "./lottery-goods-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports